import { createRoot } from 'react-dom/client'
import { AppProviders } from '@/providers/app-providers.tsx'
import './styles.css'

const rootElement = document.getElementById('app')

if (!rootElement) {
  throw new Error('找不到应用挂载节点 #app')
}

createRoot(rootElement).render(<AppProviders />)
